import React from 'react';
import ProfileLayout from '../common/components/userProfile/ProfileLayout';
import ProjectActivitySection from '../common/components/userProfile/activity/ProjectActivitySection';

const ProfileActivityPage: React.FC = () => (
  <ProfileLayout>
    <ProjectActivitySection />
  </ProfileLayout>
);

export default ProfileActivityPage;
